import React from 'react'
import { Card } from 'react-bootstrap'
import Image from 'next/image'

const IMG_FEATURES: string = '/static/images/features.svg'

interface FacilityFeaturesCardProps {
    features: string[]
}

const FacilityFeaturesCard: React.FC<FacilityFeaturesCardProps> = ({ features }) => {
    if (!features || features.length === 0) {
        return null
    }

    return (
        <Card className="mb-3">
            <Card.Body className="d-flex flex-column align-items-center">
                <Card.Title className="text-center">
                    <Image src={IMG_FEATURES} alt="facility features" width={100} height={100} />
                    <h4><strong>Facility Features</strong></h4>
                </Card.Title>
                <ul className="pl-4">
                    {features.map((name, index) => (
                        <li key={index}>{name}</li>
                    ))}
                </ul>
            </Card.Body>
        </Card>
    )
}

export default FacilityFeaturesCard
